import { styled } from '@mui/material/styles';

export const StyledWrapperMigratedUsers = styled('div')(
  ({ theme }) => `
  
  margin-top: ${theme.DS_spacing(['md'])};
  margin-bottom: ${theme.DS_spacing(['xl'])};
  > div {
   border-color: ${theme.DS_palette.border.form};
  }
 



  ${theme.breakpoints.up('lg')} {
   margin-top: ${theme.DS_spacing(['xl'])};
    > div {
      padding: ${theme.DS_spacing(['lg'])};
    }
  }

   ol {
    margin-top: ${theme.DS_spacing(['xxs'])};
  }

`,
);

export const StyledDS_ButtonLink = styled('div')(
  ({ theme }) => `
     a{
     margin: ${theme.DS_spacing(['md'])} 0;
     width: 100%;
     max-width: unset;
     text-transform: uppercase;
     }
`,
);

export const StyledImageWrapper = styled('div')(
  ({ theme }) => `
   .gatsby-image-wrapper {
    border-radius: 100%;
    aspect-ratio: 1 / 1;
    width: 60px;
    height: 60px;
   }
   
   ${theme.breakpoints.up('lg')} {
     width: 70px;
     height: 70px;
 
  }
  
`,
);

export const StyledMigrationHeaderWrapper = styled('div')(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.DS_spacing(['sm'])};
  margin-bottom:  ${theme.DS_spacing(['xxs'])};
    
  h3 {
    text-decoration: underline  2px solid rgb(241, 42, 46);
    padding-bottom: ${theme.DS_spacing(['xxs'])};
    
  }
  
  ${theme.breakpoints.up('lg')} {
   gap: ${theme.DS_spacing(['xs'])};
 
  }
  
`,
);
